function calculateInlineScore(element, property) {
    const inline = element.style[property];
    return inline ? {
        selector: "! undefined !",
        specificity: 10000 + (new String(inline).match(/\s!important/gi) ? 100000 : 0),
        style: inline
    } : undefined;
}
export { calculateInlineScore };
